import { ButtonGroup, Icon } from '@toggle/design-system';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useFlags } from '~/stores/use-flags/useFlags';

import styles from './CategoryTabs.module.scss';
import { CategoryType } from './HistorySidebar';

interface Category {
  label: ReactNode;
  value: CategoryType;
}

interface CategoryTabsProps {
  category: CategoryType;
  changeCategory: (category: CategoryType) => void;
}

export const CategoryTabs = ({
  category,
  changeCategory,
}: CategoryTabsProps) => {
  const { t } = useTranslation(['chat']);
  const isScheduledTaskEnabled = useFlags(state =>
    state.getFeatureFlagState('scheduled_task_feature')
  );

  const allCategories: Category[] = [
    {
      label: (
        <div className={styles.categoryLabel}>{t('chat:historyTab.all')}</div>
      ),
      value: 'all',
    },
    {
      label: (
        <div className={styles.categoryLabel}>
          <Icon
            iconName="Bookmarked"
            size={16}
            fillColor={
              category === 'bookmarked'
                ? 'var(--icon-primary)'
                : 'var(--icon-default)'
            }
          />
          {!isScheduledTaskEnabled && <>{t('chat:historyTab.bookmarked')}</>}
        </div>
      ),
      value: 'bookmarked',
    },
    {
      label: (
        <div className={styles.categoryLabel}>
          <Icon
            iconName="Clock"
            size={16}
            fillColor={
              category === 'scheduled'
                ? 'var(--icon-primary)'
                : 'var(--icon-default)'
            }
          />
        </div>
      ),
      value: 'scheduled',
    },
  ];

  const categories = isScheduledTaskEnabled
    ? allCategories
    : allCategories.filter(cat => cat.value !== 'scheduled');

  const handleCategoryChange = (index: number) => {
    changeCategory(categories[index].value);
  };

  return (
    <div
      className={styles.categoryTabsWrapper}
      onClick={e => e.stopPropagation()}
    >
      <ButtonGroup
        className={styles.styledButtonGroup}
        labels={categories.map(cat => cat.label)}
        ariaLabels={categories.map(cat =>
          cat.value === 'scheduled'
            ? t('chat:historyTab.scheduledTasks')
            : t(`chat:historyTab.${cat.value}`)
        )}
        activeIndex={categories.findIndex(cat => cat.value === category)}
        onClick={handleCategoryChange}
      />
    </div>
  );
};
